var redefine = require('./_redefine');
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/modules/_redefine-all.js
// module id = 150
// module chunks = 168707334958949